import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpService } from 'src/app/core/services/http/http.service';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-external-pinsheet-v2',
  templateUrl: './external-pinsheet-v2.component.html',
  styleUrls: ['./external-pinsheet-v2.component.scss']
})
export class ExternalPinsheetV2Component implements OnInit {
  @ViewChild("messageDialog") messageDialogRef: TemplateRef<any>;
  @ViewChild("miniGridDialog") miniGridDialogRef: TemplateRef<any>;
  @ViewChild("holeLocationMissingGreensRef") holeLocationMissingGreensRef: TemplateRef<any>
  @ViewChild("holeLocationMessageWarningRef") holeLocationMessageWarningRef: TemplateRef<any>
  queryParams: any;
  baseUrl: string = environment.BASE_URL;
  popupMessage: string = '';
  isError: boolean = false;
  summaryData: any = [];
  cols: number = 6;
  rowHeight: any;
  clientData: any;
  has27Green: boolean = false;
  has36Green: boolean = false;
  isMultipleCourseClient: boolean = false;
  isMultiplePinsheetCourse: boolean = false;
  selectedCourseId: number = 0;
  courseLabel: string = ''
  has27Course1: any = [];
  has27Course2: any = [];
  has27Course3: any = [];
  has36Course1: any = [];
  has36Course2: any = [];
  has36Course3: any = [];
  has36Course4: any = [];
  primaryGreens: any = [];
  secondaryGreens: any = [];
  course1Name: string;
  course2Name: string;
  course3Name: string;
  course4Name: string;
  courseList: any;
  greenWidth: any;
  greenHeight: any;
  hasSummaryResponse: boolean = false;
  selectedGreen: any;
  selectedGreenId: any;
  pinsheetList: any = [];
  isDesktop: boolean = true;
  allowHamburgerClick: boolean = false;
  swipeCoord: [number, number];
  swipeTime: number;
  cachedGreenList: any = [];
  momentFun: any = moment;
  pinsheetDate: any;
  currentIndex: number = 0;
  externalAccesskey: string;
  showFrontSideLines: boolean = true
  missedHoleGreenGroup: any =[]
  missedHoleGreens: any = []
  noHoleLocationsData: any;
  greenList: any | [];
  holeLessGreens: any = [];
  holeLessGreensIn27Course1: any = [];
  holeLessGreensIn27Course2: any = [];
  holeLessGreensIn27Course3: any = [];
  holeLessGreensIn36Course1: any = [];
  holeLessGreensIn36Course2: any = [];
  holeLessGreensIn36Course3: any = [];
  holeLessGreensIn36Course4: any = [];
  holeLessGreensInPrimaryGreens: any = [];
  holeLessGreensInSecondaryGreens: any = [];
  groupedCourseSet: any = null
  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private httpClient: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private dialog: MatDialog,
    private router: Router,
    private cookieService: CookieService,
    private httpService: HttpService,
    private loginService: LoginService,
  ) { 
  }
  
  ngOnInit(): void {
    this.isDesktop = window.innerWidth >= 1025
    this.ngxLoader.start()
  }
  
  ngAfterViewInit() {
    this.pinsheetDate = this.momentFun(new Date()).format('YYYY-MM-DD')
    this.activatedRoute.queryParams.subscribe(params => {
      this.queryParams = params
    })
  
    if(!this.queryParams['accessKey']){
      this.ngxLoader.stop()
      this.isError = true
      this.popupMessage = 'Access key is required.'
      this.dialog.open(this.messageDialogRef)
    }
    else {
      this.externalAccesskey = this.queryParams['accessKey']
      if(this.queryParams['pinsheetDate']) {
        this.pinsheetDate = this.queryParams['pinsheetDate']
      }
      this.getExternalPinsheet()
    }
  }

  updateQueryParams(queryParam: Params) {
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryParam,
        queryParamsHandling: 'merge'
      }
    )
  }

  getGreenDimension() {
    let greenContainer = <HTMLElement>document.querySelector(".pinsheet-green-container")
    let width = greenContainer?.clientWidth
    let height = greenContainer?.clientHeight
    let dimension = width < height ? Math.round(width*0.75) : Math.round(height*0.75)
    return dimension
  }

  onGreenSelection(id: any, addCourseParam: boolean = false) {
    let cachedIndex = this.cachedGreenList.findIndex((v: any) => v.Id == id)
    this.selectedGreenId = id
    if(cachedIndex >= 0) {
      this.selectedGreen = this.cachedGreenList[cachedIndex]
    }
    else {
      this.GetGreen(this.selectedGreenId, this.summaryData.PinsheetID, this.getGreenDimension())
    }

    //update query params
    let index = this.summaryData.GreenList.findIndex((g: any) => g.Id == this.selectedGreenId)
    if(index >= 0) {
      this.currentIndex = index
      let param: any = { page: this.currentIndex + 1 }

      if(addCourseParam)
        param['course'] = this.selectedCourseId

      this.updateQueryParams(param)
    }
  }

  changeSelectedGreen(previous: boolean = false) {
    let index = this.summaryData.GreenList.findIndex((g: any) => g.Id == this.selectedGreen.Id)
    if(index >= 0) 
      this.onGreenSelection(this.summaryData.GreenList[previous ? index - 1 : index + 1].Id)
  }

  GetGreen(greenId: any, pinsheetId: any, dims: any, forCache: boolean = false) {
    this.ngxLoader.start()
    let headers = new HttpHeaders({
      "accessKey": `${this.queryParams['accessKey']}`
    })
    let httpOptions : any = {
      headers: headers
    };
    let url = `/api/pinsheet/external/green?pinsheetId=${pinsheetId}&greenId=${greenId}&width=${dims}&height=${dims}&showFrontSideLines=${this.showFrontSideLines}`
    this.httpClient.get(`${this.baseUrl}${url}`, httpOptions)
    .subscribe(
      (data:  any) => {
        this.ngxLoader.stop()
        if(data.Status == 'Success') {
          if(!forCache) {
            this.selectedGreen = data.Data
          }
          this.addGreenToCachedList(data.Data, greenId)
        }
      }
    )
  }

  setCourseSelectedValue(value: string) {
    this.courseLabel = value
  }

  onCourseSelection(value: string) {
    this.selectedCourseId = +value
    if(this.isDesktop) {
      this.getExternalPinsheet()
    }
    else {
      this.summaryData = this.pinsheetList.find((v: any) => v.courseId == this.selectedCourseId)
      this.allowHamburgerClick = this.summaryData.GreenList.length > 0
      if(this.summaryData.GreenList.length > 0) {
        this.cachedGreenList = []
        this.onGreenSelection(this.summaryData.GreenList[0].Id, true)
        this.cacheGreens(this.summaryData.GreenList)
      }
      else {
        this.updateQueryParams({ course: this.selectedCourseId })
      }
    }
  }

  getExternalPinsheet() {
    this.ngxLoader.start()
    let headers = new HttpHeaders({
      "accessKey": `${this.queryParams['accessKey']}`
    })
    let httpOptions : any = {
      headers: headers
    };
    this.hasSummaryResponse = false
    let courseId = this.selectedCourseId
    let summaryUrl = `/api/pinsheet/external/summary?pinsheetDate=${this.pinsheetDate}`
    let showFrontSideLineParam = `&showFrontSideLines=${this.showFrontSideLines}`
    summaryUrl = `${summaryUrl}${this.isDesktop ? `&width=160&height=160` : `&forDesktop=${this.isDesktop}`}${showFrontSideLineParam}`
    if(courseId && this.isDesktop)
      summaryUrl = summaryUrl + `&courseId=${courseId}` 
    this.httpClient.get(`${this.baseUrl}${summaryUrl}`, httpOptions)
    .subscribe(
      (data:  any) => {
        this.ngxLoader.stop()
        if(data.Status == 'Success') {
          this.hasSummaryResponse = true

          this.clientData = data.Data.client
          this.courseList = data.Data.courseList
          this.has27Green = this.clientData.Has27Green
          this.has36Green = this.clientData.Has36Green
          this.isMultipleCourseClient = this.clientData.IsMultipleCourseClient
          this.groupedCourseSet = this.clientData.GroupedCourseSet

          let courseIndex = 0
          let courseParam = +this.queryParams['course']
          if(courseParam && courseParam != NaN) {
            let index = this.courseList.findIndex((v: any) => v.CourseID == courseParam)
            courseIndex = index >= 0 ? index : courseIndex
          }

          this.courseList.map((v: any) => {
            v.name = v.CourseName
            v.id = v.CourseID
          })
          if(this.selectedCourseId == 0) {
            this.selectedCourseId = this.courseList[courseIndex].CourseID
            this.setCourseSelectedValue(this.courseList[courseIndex].CourseName)
          }

          let queryParamsToAdd: any = {}
          if(!this.isDesktop && (this.isMultipleCourseClient || (this.has27Green && this.isGroupedCourse()) || (this.has36Green && this.isGroupedCourse()))) {
            queryParamsToAdd["course"] = this.selectedCourseId
          }
          else {
            queryParamsToAdd["course"] = null
          }

          if(this.isDesktop) {
            this.summaryData = data.Data.pinsheet
            queryParamsToAdd["page"] = null
          }
          else {
            this.pinsheetList = data.Data.pinsheetList
            this.summaryData = data.Data.pinsheetList[courseIndex]
          }

          this.greenList = this.summaryData.GreenList
          this.isMultiplePinsheetCourse = this.summaryData.IsMultiplePinsheetCourse
          this.allowHamburgerClick = this.summaryData.GreenList.length > 0
          if(!this.isDesktop && this.summaryData.GreenList.length > 0) {
            let page = +this.queryParams['page']
            if(page && page != NaN) {
              this.currentIndex = (page < 1 ? 1 : page > this.summaryData.GreenList.length ? this.summaryData.GreenList.length : page) - 1
            }
            else {
              queryParamsToAdd["page"] = this.currentIndex + 1
            }
            this.cachedGreenList = []
            this.onGreenSelection(this.summaryData.GreenList[this.currentIndex].Id)
            this.cacheGreens(this.summaryData.GreenList)
          }
          this.updateQueryParams(queryParamsToAdd)

          if (this.summaryData.IsMultiplePinsheetCourse) {
            this.primaryGreens = this.summaryData.GreenList.filter((v: any) => {
              if (v.IsPrimary) {
                return v
              }
            })
            this.secondaryGreens = this.summaryData.GreenList.filter((v: any) => {
              if (!v.IsPrimary) {
                return v
              }
            })
          }
          if (this.has27Green && this.isGroupedCourse()) {
            this.has27Course1 = this.summaryData.GreenList.filter((v: any) => {
              if (v.CourseID == this.courseList[0].CourseID) {
                return v
              }
            })
            this.has27Course2 = this.summaryData.GreenList.filter((v: any) => {
              if (v.CourseID == this.courseList[1].CourseID) {
                return v
              }
            })
            this.has27Course3 = this.summaryData.GreenList.filter((v: any) => {
              if (v.CourseID == this.courseList[2].CourseID) {
                return v
              }
            })
          }
          if (this.has36Green && this.isGroupedCourse()) {
            this.has36Course1 = this.summaryData.GreenList.filter((v: any) => {
              if (v.CourseID == this.courseList[0].CourseID) {
                return v
              }
            })
            this.has36Course2 = this.summaryData.GreenList.filter((v: any) => {
              if (v.CourseID == this.courseList[1].CourseID) {
                return v
              }
            })
            this.has36Course3 = this.summaryData.GreenList.filter((v: any) => {
              if (v.CourseID == this.courseList[2].CourseID) {
                return v
              }
            })
            this.has36Course4 = this.summaryData.GreenList.filter((v: any) => {
              if (v.CourseID == this.courseList[3].CourseID) {
                return v
              }
            })
          }
          if (this.summaryData.GreenList.length > 0 && this.hasAnyGreenMissingHoles()) {
              const warningPopupData = {
                courses: this.courseList,
                has27Green: this.has27Green,
                has36Green: this.has36Green,
                isMultiplePinsheetCourse: this.isMultiplePinsheetCourse,
                course1: this.has27Green ? this.holeLessGreensIn27Course1 : this.has36Green ? this.holeLessGreensIn36Course1 : this.isMultiplePinsheetCourse ? this.holeLessGreensInPrimaryGreens : [],
                course2: this.has27Green ? this.holeLessGreensIn27Course2 : this.has36Green ? this.holeLessGreensIn36Course2 : this.isMultiplePinsheetCourse ? this.holeLessGreensInSecondaryGreens : [],
                course3: this.has27Green ? this.holeLessGreensIn27Course3 : this.has36Green ? this.holeLessGreensIn36Course3 : [],
                course4: this.has36Green ? this.holeLessGreensIn36Course1 : [],
                greens: this.holeLessGreens,
              };
              this.noHoleLocationsData = warningPopupData
              this.dialog.open(this.holeLocationMessageWarningRef, { disableClose: false , panelClass: 'missed-hole-locations-warning'});
            }
        }
        else if(data.Status == 'Error') {
          this.hasSummaryResponse = false
          this.isError = true
          this.popupMessage = data.Message
          this.dialog.open(this.messageDialogRef)
        }
      },
      (errorData) => {
        this.ngxLoader.stop()
        console.error(errorData.error.Message);
        if(errorData.status == 401 || errorData.status == 400) {
          this.isError = true
          this.popupMessage = errorData.error.Message
          this.dialog.open(this.messageDialogRef)
        }
      }
    )
  }

  onPopupClose() {
    this.dialog.closeAll()
  }

  openMiniGrid() {
    if(this.summaryData.GreenList.length > 0){
      if((this.has27Green || this.has36Green) && this.isGroupedCourse()) {
        this.dialog.open(this.miniGridDialogRef, { 
          panelClass: 'ext-nine-green-grid-modal', 
          maxWidth: '100%'
        })
      }
      else {
        this.dialog.open(this.miniGridDialogRef, {
          panelClass: 'ext-grid-modal'
        })
      }
    }
  }

  swipe(e: TouchEvent, when: string): void {
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();
  
    if (when === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else if (when === 'end') {
      const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;
  
      if (duration < 1000 //
        && Math.abs(direction[0]) > 30 // Long enough
        && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
          const swipe = direction[0] < 0 ? 'next' : 'previous';
          this.changeSelectedGreen(swipe == 'previous')
      }
    }
  }

  addGreenToCachedList(green: any, id: any) {
    let cachedIndex = this.cachedGreenList.findIndex((v: any) => v.Id == green.Id)
    if(cachedIndex >= 0) {
      this.cachedGreenList[cachedIndex] = green
    }
    else {
      this.cachedGreenList.push(green)
    }
  } 

  cacheGreens(greenList: any) {
    greenList.map((v: any, index: number) => {
      if(index != this.currentIndex) {
        this.GetGreen(v.Id, this.summaryData.PinsheetID, this.getGreenDimension(), true)  
      }
    })
  }

  gotoLoginPage() {
    if(this.authService.isLoggedIn){
      window.open(window.location.origin + '/pinsheet', '_blank');
    }else{
      window.open(window.location.origin + `/login?returnPath=pinsheet`,'_blank')
    }
  }

  toogleFrontSideLines(){
    this.showFrontSideLines = ! this.showFrontSideLines
    if(this.isDesktop) {
      this.getExternalPinsheet()
    }else{
      this.cachedGreenList = []
      this.onGreenSelection(this.summaryData.GreenList[0].Id, true)
      this.cacheGreens(this.summaryData.GreenList)
    }
  }

  hasAnyGreenMissingHoles() {
    this.holeLessGreensIn27Course1 = []
    this.holeLessGreensIn27Course2 = []
    this.holeLessGreensIn27Course3 = []
    this.holeLessGreensIn36Course1 = []
    this.holeLessGreensIn36Course2 = []
    this.holeLessGreensIn36Course3 = []
    this.holeLessGreensIn36Course4 = []
    this.holeLessGreensInPrimaryGreens = []
    this.holeLessGreensInSecondaryGreens = []
    this.holeLessGreens = []

    if(this.has27Green) {
      this.holeLessGreensIn27Course1 = this.filterGreensWithMissingHoles(this.has27Course1)
      this.holeLessGreensIn27Course2 = this.filterGreensWithMissingHoles(this.has27Course2)
      this.holeLessGreensIn27Course3 = this.filterGreensWithMissingHoles(this.has27Course3)
    } else if(this.has36Green) {
      this.holeLessGreensIn36Course1 = this.filterGreensWithMissingHoles(this.has36Course1)
      this.holeLessGreensIn36Course2 = this.filterGreensWithMissingHoles(this.has36Course2)
      this.holeLessGreensIn36Course3 = this.filterGreensWithMissingHoles(this.has36Course3)
      this.holeLessGreensIn36Course4 = this.filterGreensWithMissingHoles(this.has36Course4)
    } else if(this.isMultiplePinsheetCourse) {
      this.holeLessGreensInPrimaryGreens = this.filterGreensWithMissingHoles(this.primaryGreens)
      this.holeLessGreensInSecondaryGreens = this.filterGreensWithMissingHoles(this.secondaryGreens)
    } else if(!this.has27Green && !this.has36Green && !this.isMultiplePinsheetCourse) {
      this.holeLessGreens = this.filterGreensWithMissingHoles(this.greenList.GreenList)
    }
    
    return (
      this.holeLessGreens.length > 0 ||
      this.holeLessGreensIn27Course1.length > 0 ||
      this.holeLessGreensIn27Course2.length > 0 ||
      this.holeLessGreensIn27Course3.length > 0 ||
      this.holeLessGreensIn36Course1.length > 0 ||
      this.holeLessGreensIn36Course2.length > 0 ||
      this.holeLessGreensIn36Course3.length > 0 ||
      this.holeLessGreensIn36Course4.length > 0 ||
      this.holeLessGreensInPrimaryGreens.length > 0 ||
      this.holeLessGreensInSecondaryGreens.length > 0
    );
  }

  filterGreensWithMissingHoles(greens: any[]) {
    return greens.filter(
      (green: any) => green.Center == "" || green.Position == "" || green.PositionX == "" || green.PositionY == ""
    );
  }

  hasAnyGreenMissingHoleLocation() {
    this.missedHoleGreenGroup = []
    this.missedHoleGreens = []
    if (this.greenList.length > 0) {
      this.greenList.map((green: any) => {
        if (green.Center == "" || green.Position == "" || green.PositionX == "" || green.PositionY == "") {
          if (!this.missedHoleGreens.some((g: any) => g.Id == green.Id)) {
            this.missedHoleGreens.push(green);
          }
        }
      });
    }
    const groupedGreens: any = [];
    this.missedHoleGreens.forEach((green: any) => {
      let courseId = green.CourseID
      let courseGroup = groupedGreens.find((group: any) => group.CourseID == courseId);
      let courseName = this.courseList.find((course: any) => course.CourseID == courseId).CourseName
      // If the course group doesn't exist, create it
      if (!courseGroup) {
        courseGroup = { courseId, courseName, greens: [] };
        groupedGreens.push(courseGroup);
      }
      // Add the current green to the course group
      courseGroup.greens.push(green);
    });
    this.missedHoleGreenGroup = groupedGreens;
    return this.missedHoleGreenGroup.length > 0
  }

  onClickPrint(){
    if(!this.summaryData.HasPinsheet){
      return
    }
    if(this.hasAnyGreenMissingHoleLocation()) {
      this.dialog.closeAll();
      this.ngxLoader.stop();
      this.dialog.open(this.holeLocationMissingGreensRef, { disableClose: false });
    }else{
      this.printPinsheet();
    }
  }

  onClickFormat(){
    if(this.authService.isLoggedIn){
      this.cookieService.set('externalPinsheetClientId', this.clientData.ClientId, undefined, '/')
      this.cookieService.set('externalPinsheetCourseId', this.selectedCourseId.toString(), undefined, '/')
      // const clientId = this.cookieService.get('clientId')
      // const courseId = this.cookieService.get('courseId')
      // if(Number(clientId) != Number(this.clientData.ClientId) || this.selectedCourseId != Number(courseId)){
      //   this.cookieService.set('externalClientId',this.clientData.ClientId.toString(), undefined, '/')
      //   this.cookieService.set('externalCourseId',this.selectedCourseId.toString(), undefined, '/')
      // }
      const formatPath = `returnPath=${'/format'}&clientId=${this.clientData.ClientId}&courseId=${this.selectedCourseId}`
      this.cookieService.set('returnPath', window.location.origin + '?' +formatPath, undefined, '/')
      window.open(window.location.origin + '/format', '_blank');
    }else{
      const formatPath = `returnPath=${'/format'}&clientId=${this.clientData.ClientId}&courseId=${this.selectedCourseId}`
      const encodedReturnPath = encodeURIComponent(formatPath)
      window.open(window.location.origin + `/login?${encodedReturnPath}`,'_blank')
    }
  }

  onClickManageGreens() {
    if(this.authService.isLoggedIn){
      this.redirectToPath('/manage')
    }else{
      const manageGreensPath = `returnPath=${'/manage'}&clientId=${this.clientData.ClientId}&courseId=${this.selectedCourseId}`
      const encodedReturnPath = encodeURIComponent(manageGreensPath)
      window.open(window.location.origin + `/login?${encodedReturnPath}`,'_blank')
    }
  }

  onClickCalendar() {
    this.cookieService.set('openCalendar', "true", undefined, '/')
    if(this.authService.isLoggedIn){
      this.redirectToPath('/pinsheet')
    }else{
      const summaryPagePath = `returnPath=${'/pinsheet'}&clientId=${this.clientData.ClientId}&courseId=${this.selectedCourseId}`
      const encodedReturnPath = encodeURIComponent(summaryPagePath)
      window.open(window.location.origin + `/login?${encodedReturnPath}`,'_blank')
    }
  }

  redirectToPath(path: string) {
    this.loginService.getUserInfo()
    .subscribe((user) => {
      if(user.Status == 'Success'){
        user = user.Data
        if(user.RightsId == 1){
          this.cookieService.set('clientId', this.clientData.ClientId, undefined, '/')
          this.cookieService.set('courseId', this.selectedCourseId.toString(), undefined, '/')
        }
        else{
          this.cookieService.set('externalPinsheetClientId', this.clientData.ClientId, undefined, '/')
          this.cookieService.set('externalPinsheetCourseId', this.selectedCourseId.toString(), undefined, '/')
        }
        var returnPath = `returnPath=${path}`
        this.cookieService.set('returnPath', window.location.origin + '?' +returnPath, undefined, '/')
        window.open(window.location.origin + path, '_blank');
      }
    })
  }

  printAnyways() {
    this.dialog.closeAll();
    setTimeout(() => {
      this.printPinsheet();
    }, 10);
  }

  printPinsheet() {
    this.ngxLoader.start()
    let headers = new HttpHeaders({
      "accessKey": `${this.queryParams['accessKey']}`
    })
    let httpOptions : any = {
      headers: headers
    };
    let printUrl = `/api/pinsheet/external/pinsheet/pdf?courseID=${this.selectedCourseId}&pinsheetDate=${this.pinsheetDate}&showFrontSideLines=${this.showFrontSideLines}`
    this.httpClient.get(`${this.baseUrl}${printUrl}`, httpOptions)
    .subscribe((data: any) => {
      this.ngxLoader.stop()
        if(data.Status == 'success') {
          let printData = data.Data
          this.previewPdf(printData)
        }
    })
  }

  previewPdf(base64String: string) {
    const byteArray = this.base64ToBytes(base64String)
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const blobUrl = URL.createObjectURL(blob);
    if(!this.isDesktop){
      const newWindow = window.open(blobUrl, '_blank');
      if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
        window.location.href = blobUrl;
      }
    }else{
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
  
      document.body.appendChild(iframe);
  
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        }, 0);
      };
    }

  }

  base64ToBytes(base64: string) {
    const binString = atob(base64);
    return Uint8Array.from(binString, (m) => m.charCodeAt(0));
  }

  closeWarning() {
    this.dialog.closeAll();
  }

  isGroupedCourse() {
    if(this.groupedCourseSet?.length == 0) return true
    if(this.groupedCourseSet == null) return false
    if(this.selectedCourseId == null || this.selectedCourseId == undefined || this.selectedCourseId == 0) return false
    return this.groupedCourseSet.includes(Number(this.selectedCourseId))
  }
   
  isUngroupedCoursePresent() {
    if(this.courseList == null || this.courseList == undefined || this.groupedCourseSet == null) return false
    var unGroupedCourses = this.courseList.filter((cl:any) => !this.groupedCourseSet.includes(cl.CourseID))
    
    return (this.has27Green || this.has36Green) && unGroupedCourses.length > 0
  }

}
